'use client';

import { useState } from 'react';
import Image from "next/image";
import Link from "next/link";
import { Facebook, Linkedin, MapPin, Award } from 'lucide-react';
import MobileMenu from "@/components/MobileMenu";
import ContactButton from "@/components/ContactButton";

export default function PageHeader() {
  const [aboutOpen, setAboutOpen] = useState(false);

  return (
    <>
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:bg-white focus:text-brand-red focus:px-4 focus:py-2 focus:rounded focus:font-bold"
      >
        Skip to main content
      </a>
      <header className="bg-brand-red text-white sticky top-0 z-50">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <Link href="/" className="flex items-center">
          <Image
            src="/images/logo.svg"
            alt="AnswerOne logo"
            width={404}
            height={50}
            style={{ width: 'auto', height: '48px' }}
            priority
            sizes="180px"
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-8 relative">
          <Link href="/capabilities" className="hover:opacity-80 transition">Capabilities</Link>
          <Link href="/services" className="hover:opacity-80 transition">Plans</Link>
          <Link href="/industry" className="hover:opacity-80 transition">Industries</Link>
          
          {/* About dropdown */}
          <div 
            className="relative group"
            onMouseEnter={() => setAboutOpen(true)}
            onMouseLeave={() => setAboutOpen(false)}
          >
            <button className="hover:opacity-80 transition flex items-center gap-1">
              About
              <span className={`text-xs transition-transform ${aboutOpen ? 'rotate-180' : ''}`}>▼</span>
            </button>
            {/* Always rendered in the DOM (not conditionally mounted) so these links exist in the
                static-exported HTML regardless of hover state — a JS-gated `{aboutOpen && ...}` here
                previously meant /the-answerone-way, /locations, and /about had zero crawlable nav links. */}
            <div
              className={`absolute top-full left-0 pt-2 w-48 z-[100] ${aboutOpen ? '' : 'opacity-0 invisible pointer-events-none'}`}
            >
              <div className="bg-brand-red border border-white rounded shadow-lg py-2">
                <Link href="/the-answerone-way" className="block px-4 py-2 hover:opacity-80 transition">
                  Why AnswerOne
                </Link>
                <Link href="/locations" className="block px-4 py-2 hover:opacity-80 transition">
                  Areas We Serve
                </Link>
                <Link href="/about" className="block px-4 py-2 hover:opacity-80 transition">
                  About AnswerOne
                </Link>
              </div>
            </div>
          </div>
          
          <Link href="/contact" className="hover:opacity-80 transition">Contact</Link>
          
          <div className="flex items-center gap-4 ml-4 border-l border-white/20 pl-4">
            <a href="https://www.facebook.com/AnswerOne.NY" target="_blank" rel="noopener noreferrer" className="hover:opacity-80 transition" aria-label="Facebook">
              <Facebook size={20} />
            </a>
            <a href="https://www.linkedin.com/company/answerone" target="_blank" rel="noopener noreferrer" className="hover:opacity-80 transition" aria-label="LinkedIn">
              <Linkedin size={20} />
            </a>
            <a href="https://www.google.com/maps/search/?api=1&query=AnswerOne+Inc%2C+7014+13th+Avenue%2C+Brooklyn%2C+NY+11228" target="_blank" rel="noopener noreferrer" className="hover:opacity-80 transition" aria-label="Google Business Profile">
              <MapPin size={20} />
            </a>
            <a href="https://www.bbb.org/us/ny/brooklyn/profile/answering-service/answer-one-0121-2371" target="_blank" rel="noopener noreferrer" className="hover:opacity-80 transition" aria-label="BBB Profile">
              <Award size={20} />
            </a>
          </div>
        </nav>

        <ContactButton variant="header" />

          {/* Mobile menu */}
          <MobileMenu />
        </div>
      </header>
    </>
  );
}
